import { Button } from "@fluentui/react-northstar";
import FormState, { FieldDescriptor } from "@shopify/react-form-state";
import { randomString } from "@teams/client-shared";
import { TeamsSurveyReminder } from "@teams/types";
import React from "react";

import { PollyIcon } from "../PollyIcon";
import { ReminderRow } from "./ReminderRow";

type Props = {
  field: FieldDescriptor<TeamsSurveyReminder[]>;
  disabled?: boolean;
  maxEntries: number;
};

export const ReminderSelector: React.FC<Props> = ({ field, maxEntries, disabled }) => {
  const addNewReminderDelta = () => {
    if (field.value.length >= maxEntries) {
      return;
    }

    field.onChange([...field.value, { id: randomString(), duration: "PT30M" }]);
  };

  return (
    <div className="reminder-selector">
      <FormState.List field={field} getChildKey={item => item.id as string}>
        {(listFields, index) => {
          return (
            <ReminderRow
              key={index}
              reminder={listFields}
              onRemoveReminder={id => {
                field.onChange([...field.value.filter(r => r.id !== id)]);
              }}
            />
          );
        }}
      </FormState.List>

      <Button
        data-tname="select-reminder"
        className="reminder-selector__button"
        disabled={
          disabled ||
          (maxEntries !== undefined && maxEntries > 0 && field.value.length >= maxEntries)
        }
        onClick={ev => {
          ev.preventDefault();
          addNewReminderDelta();
        }}
        content={<PollyIcon icon="add-choice-icon" label="Add reminder" />}
      />
    </div>
  );
};
